import Hero from './Hero';
import Features from './Features';
import Testimonials from './Testimonials';
import Pricing from './Pricing';
import FAQ from './FAQ';
import Footer from '../../components/Footer';

export default function Home() {
    return (
        <>
          <Hero />
          <Features />
          {/* <Testimonials /> */}
          {/* <Pricing /> */}
          <FAQ />
          <Footer />
        </>
    );
}